import React from 'react';
import styled from 'styled-components';
import {CONSTS} from './_constants';

const Avatar = ({src, className}) => (
    <div className={className}>
        <img src={src} />
    </div>
)

const StyledAvatar = styled(Avatar)`
    width: ${props => props.size ? props.size : 40}px;
    height: ${props => props.size ? props.size : 40}px;
    border-radius: ${props => props.size ? props.size : 40}px;
    margin: 0;
    overflow:hidden;
    display: inline-block;
    vertical-align: middle;
    > img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
    }
`

export default StyledAvatar;